import { CalendarDate } from '@internationalized/date';
/** The date the empty field shows as its example, as long as the field allows it. */
const EXAMPLE = new CalendarDate(2015, 3, 1);
/** How far the year list reaches without a bound: back to a birth year, ahead to a contract's end. */
const YEARS_BACK = 120;
const YEARS_AHEAD = 50;
/** A date pulled into the range the field allows. */
export function clampDate(date, min, max) {
    if (min && date.compare(min) < 0)
        return min;
    if (max && date.compare(max) > 0)
        return max;
    return date;
}
/**
 * The realistic example the empty field shows („z. B. 01.03.2015“): the same date everywhere,
 * unless the field does not allow it - then the first of a month inside the range, so the
 * example never shows a date the field would refuse.
 */
export function exampleDate(min, max) {
    if (min && EXAMPLE.compare(min) < 0) {
        const firstAfter = min.day === 1 ? min : min.set({ day: 1 }).add({ months: 1 });
        return max && firstAfter.compare(max) > 0 ? min : firstAfter;
    }
    if (max && EXAMPLE.compare(max) > 0) {
        const firstOf = max.set({ day: 1 });
        return min && firstOf.compare(min) < 0 ? max : firstOf;
    }
    return EXAMPLE;
}
/** The years the year list offers, ascending: the field's bounds, or a lifetime around today. */
export function yearRange(min, max, today) {
    const first = min?.year ?? Math.min(today.year - YEARS_BACK, max?.year ?? today.year);
    const last = max?.year ?? Math.max(today.year + YEARS_AHEAD, first);
    return Array.from({ length: last - first + 1 }, (_, index) => first + index);
}
/** Whether a whole month lies outside the range the field allows - it cannot be picked then. */
export function isMonthOutside(year, month, min, max) {
    const key = year * 12 + month;
    return ((min !== undefined && key < min.year * 12 + min.month) ||
        (max !== undefined && key > max.year * 12 + max.month));
}
//# sourceMappingURL=date-logic.js.map